/* this file is transformed by vux-loader */

/* eslint-disable */
import base from '../base';
import http from '../http';
var AcDep = {
  insert: function insert(params) {
    return http.put("".concat(base.dev, "/acDep/insert"), params);
  },
  updateByPrimaryKey: function updateByPrimaryKey(params) {
    return http.post("".concat(base.dev, "/acDep/updateByPrimaryKey"), params);
  },
  selectListPageByEntity: function selectListPageByEntity(params) {
    return http.post("".concat(base.dev, "/acDep/selectListPageByEntity"), params);
  },
  selectListByEntity: function selectListByEntity(params) {
    return http.post("".concat(base.dev, "/acDep/selectListByEntity"), params);
  },
  deleteByPrimaryKey: function deleteByPrimaryKey(userSerial) {
    return http.delete("".concat(base.dev, "/acDep/deleteByPrimaryKey"), {
      params: {
        userSerial: userSerial
      }
    });
  },
  selectByPrimaryKey: function selectByPrimaryKey(userSerial) {
    return http.get("".concat(base.dev, "/acDep/selectByPrimaryKey"), {
      params: {
        userSerial: userSerial
      }
    });
  },
  selectListByKeys: function selectListByKeys(params) {
    return http.post("".concat(base.dev, "/acDep/selectListByKeys"), params);
  },
  deleteBatchByKeys: function deleteBatchByKeys(keys) {
    return http.delete("".concat(base.dev, "/acDep/deleteBatchByKeys"), {
      params: {
        keys: keys
      }
    });
  },
  selectDinePlace: function selectDinePlace() {
    return http.get("".concat(base.dev, "/acDep/selectDinePlace"));
  },
  selectListByChoose: function selectListByChoose(params) {
    //餐厅的tree列表接口
    //  return http.get(`https://www.fastmock.site/mock/04b137d12b4c0ab981b48ca3d1158302/choose01/chooselist`)
    return http.get("".concat(base.dev, "/acDep/selectAllDep"), params);
  }
};
export default AcDep;